var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRankUp = function SvgIconRankUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.5.5 2.5 4H0l2.5-4Z",
    fill: "#2CCCD3"
  })));
};
export default SvgIconRankUp;